import axios from "axios";
import ApiList, { API } from "./apiList";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { CryptoJSDecrypt } from "./encryption";
import { format } from "date-fns";
import { isMobile, browserName } from "react-device-detect";
import moment from "moment";
import { Logout } from "../auth/auth";
import { NepaliDate } from "@zener/nepali-datepicker-react";

const WebViewBrowserName = ["WebKit", "WebView"];
function matches() {
  const output = [];
  WebViewBrowserName.forEach((word) => {
    const test = browserName.split(word);
    if (test.length > 0) {
      for (let i = 1; i < test.length; i++) {
        output.push(word);
      }
    }
  });
  return output;
}

// Hide elements for mobile app development web view
export const hideForMobileAppWebView = () => {
  if (isMobile) {
    if (browserName) {
      if (matches().length > 0) {
        return false;
      }
    }
  }
  return true;
};

export const UserToken = async () => {
  let userToken;
  if (localStorage.getItem("LI_PROFILE")) {
    userToken = JSON.parse(
      CryptoJSDecrypt(localStorage.getItem("LI_PROFILE"))
    ).UserToken;
  }
  await axios
    .post(API() + ApiList.GenerateUserToken, {
      UserToken: userToken,
    })
    .then(function (response) {
      if (response?.data?.tokenString) {
        Cookies.set("LIFE_ACCESS_TOKEN", response.data.tokenString, {
          secure: false,
        });
      } else {
        Logout();
      }
    })
    .catch(function (error) {
      toastError(error.message);
    });
};

export const PublicUserToken = async () => {
  return await axios
    .post(API() + ApiList.GenerateUserToken, {
      UserToken: "FC62BB2B-7A60-4E55-8FF0-BB549ACD4D85",
    })
    .then(function (response) {
      return response.data.tokenString;
    })
    .catch(function (error) {
      toastError(error.message);
    });
};

export const ShowLoader = () => {
  const element = document.getElementById("js-fallback-loader");
  if (element) {
    element.setAttribute("style", "display:block;");
  }
};

export const HideLoader = () => {
  setTimeout(() => {
    const element = document.getElementById("js-fallback-loader");
    if (element) {
      element.setAttribute("style", "display:none;");
    }
  }, 500);
};

export const GetUserAccessToken = () => {
  return Cookies.get("LIFE_ACCESS_TOKEN");
};

export const toastSuccess = (value) => {
  toast(value, {
    position: "bottom-right",
    autoClose: 4000,
    type: "success",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};

export const toastError = (value) => {
  toast(value, {
    position: "bottom-right",
    type: "error",
    autoClose: 4000,
    closeButton: true,
    closeOnClick: true,
    hideProgressBar: false,
  });
};

export const toastWarning = (value) => {
  toast(value, {
    position: "bottom-right",
    autoClose: 4000,
    type: "warning",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};

export const getUserProfile = () => {
  const d= localStorage.getItem("LI_PROFILE")
    ? JSON.parse(CryptoJSDecrypt(localStorage.getItem("LI_PROFILE")))
    : null;
    return d;
};

export const getUserType = () => {
  return localStorage.getItem("LI_PROFILE")
    ? JSON.parse(CryptoJSDecrypt(localStorage.getItem("LI_PROFILE"))).userType
    : null;
};

export const getUserName = () => {
  return localStorage.getItem("LI_PROFILE")
    ? JSON.parse(CryptoJSDecrypt(localStorage.getItem("LI_PROFILE"))).mobileNo
    : null;
};
export const NumberFixed = (value) => {
  return value ? parseFloat(value).toFixed(2) : null;
};

export const dateFormat = (value) => {
  return format(new Date(value.toLocaleDateString()), "yyyy-MM-dd");
};

export const currencyFormat = (num) => {
  return parseFloat(num)
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const isValidDate = (dateString) => {
  return moment(dateString, "MM/DD/YYYY", true).isValid();
};

export const numberInputOnWheelPreventChange = (e) => {
  // Prevent the input value change
  e.target.blur();

  // Prevent the page/container scrolling
  e.stopPropagation();

  // Refocus immediately, on the next tick (after the current function is done)
  setTimeout(() => {
    e.target.focus();
  }, 0);
};

export const isUserAgent = () => {
  return getUserProfile()?.AgentCode ? getUserProfile()?.AgentCode : false;
};

export function convertToCm(feet, inches) {
  const totalInches = feet * 12 + inches;
  const centimeters = totalInches * 2.54;
  return centimeters;
}

export const getMaxDate = (monthsToSubtract) => {
  return new NepaliDate().subtract(monthsToSubtract, "month");
};

export const calculateBMI = (heightFeet, heightInches, weightKg) => {
  if (!heightFeet || !weightKg || heightFeet <= 0 || weightKg <= 0) return null;

  const totalInches =
    parseFloat(heightFeet) * 12 + (parseFloat(heightInches) || 0);
  const heightInMeters = totalInches * 0.0254; // Convert inches to meters

  return weightKg / (heightInMeters * heightInMeters);
};
